/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { connect } from 'react-redux';

import { Event, Field, ImpactEnd, ImpactStart, Resolved } from './FeedItems';

const Wrapper = styled.div`
  padding: 1rem;
`;

class MaintenanceFeed extends React.Component {
  static propTypes = {
    maintenance: PropTypes.object,
    missingTranslations: PropTypes.func
  };

  render() {
    const { maintenance, missingTranslations, timezone } = this.props;

    const feedItems = [];

    const initialMaintenanceImpact  = maintenance.MaintenanceImpacts[0];

    maintenance.MaintenanceImpacts.map((maintenanceImpact, index) => {
      const startItem = {
        type: 'IMPACT_START',
        impact: maintenanceImpact,
        severity: maintenanceImpact.severity,
        postTime: maintenanceImpact.startTimeCreatedAt,
        postUpdatedTime: maintenanceImpact.startTimeModifiedAt,
        dateTime: maintenanceImpact.startTime
      };

      feedItems.push(startItem);

      if (maintenanceImpact.endTime) {
        const endItem = {
          type: 'IMPACT_END',
          impact: maintenanceImpact,
          severity: maintenanceImpact.severity,
          dateTime: maintenanceImpact.endTime,
          postTime: maintenanceImpact.startTimeCreatedAt,
          postUpdatedTime: maintenanceImpact.startTimeModifiedAt,
          duration: maintenanceImpact.endTime.diff(maintenanceImpact.startTime)
        };
        feedItems.push(endItem);
      }
    });

    maintenance.MaintenanceEvents.map((maintenanceEvent) => {
      let maintenanceEventWithinImpact = false;

      if (typeof initialMaintenanceImpact !== 'undefined') {
        const impactStartTime = initialMaintenanceImpact.startTime || '';
        const impactEndTime = initialMaintenanceImpact.endTime || '';
        maintenanceEventWithinImpact = maintenanceEvent.createdAt.isBetween(impactStartTime, impactEndTime);
      }
      const eventItem = {
        type: 'EVENT',
        event: maintenanceEvent,
        severity: maintenanceEventWithinImpact ? maintenanceEvent.severity : 'neutral',
        updateTime: maintenanceEvent.updatedAt,
        dateTime: maintenanceEvent.createdAt || null
      };

      feedItems.push(eventItem);
    });

    feedItems.sort((a, b) => {
      if (a.dateTime === null) return -1;
      if (b.dateTime === null) return 1;

      const diff = b.dateTime.diff(a.dateTime);
      if (diff !== 0) return diff;

      // Show
      if (a.type === 'IMPACT_END') return 1;
      if (b.type === 'IMPACT_END') return -1;

      if (a.type === 'IMPACT_START') return -1;
      if (b.type === 'IMPACT_START') return 1;
    });

    let currentSeverity = 'healthy';

    for (let i = feedItems.length - 1; i >= 0; i--) {
      const item = feedItems[i];  
      if (item.severity) {
        currentSeverity = item.severity;
      } if (item.type === 'IMPACT_END') {
        currentSeverity = 'healthy';
      } else {
        item.severity = currentSeverity;
      }
    }

    return (
      <Wrapper>
        { feedItems.map((feedItem, index) => {
          switch (feedItem.type) {
            case 'IMPACT_START': {
              return (
                <ImpactStart
                  feedItem={feedItem}
                  key={`${feedItem.type}-${feedItem.severity}-${index}`}
                  missingTranslations={missingTranslations}
                  region={timezone}
                />
              );
            }
            case 'IMPACT_END': {
              return (
                <ImpactEnd
                  feedItem={feedItem}
                  key={`${feedItem.type}-${feedItem.severity}-${index}`}
                  missingTranslations={missingTranslations}
                  region={timezone}
                />
              );
            }
            case 'EVENT': {
              return (
                <Event
                  feedItem={feedItem}
                  key={`${feedItem.type}-${feedItem.severity}-${index}`}
                  missingTranslations={missingTranslations}
                  region={timezone}
                />
              );
            }
            case 'RESOLVED': {
              return (
                <Resolved
                  feedItem={feedItem}
                  key={`${feedItem.type}-${feedItem.severity}-${index}`}
                  missingTranslations={missingTranslations}
                  region={timezone}
                />
              );
            }

            case 'FIELD': {
              return (
                <Field
                  feedItem={feedItem}
                  key={`${feedItem.type}-${feedItem.severity}-${index}`}
                  missingTranslations={missingTranslations}
                  region={timezone}
                />
              );
            }
            default: { return null; }
          }
        })}
      </Wrapper>
    );
  }
}

export default connect((state) => ({ timezone: state.timezonePicker }))(MaintenanceFeed);

